import { Component } from '@angular/core';

/**
 * Authentication guide (/docs/authentication) the Bearer-token header
 * shape every endpoint expects. Split out of the old single /docs
 * mega-page (see docs/overview/docs.ts) so it has its own route.
 */
@Component({
  selector: 'app-docs-authentication',
  standalone: false,
  templateUrl: './docs-authentication.html',
})
export class DocsAuthentication {}
